import Popover from 'antd/lib/popover';
import Typography from 'antd/lib/typography';
import { formatDistance } from 'date-fns';
import React, { useMemo } from 'react';
import { determineVenStatusFromTelemetry } from '../../domain/resource-telemetry';
import { IResourceTelemetryStatus } from '../../domain/resource-telemetry/interface';
import { ISite } from '../../domain/site/interface';
import { VEN_STATUS_COLOR_MAP, VenStatus } from '../../domain/ven/interface';
import { CircleIcon } from '../icons/icons';

const { Text } = Typography;

interface IResourceTelemetryStatusCellProps {
    site?: ISite | null;
}

export const ResourceTelemetryStatusCell: React.FC<IResourceTelemetryStatusCellProps> = ({ site }) => {
    const resourceTelemetryStatus: IResourceTelemetryStatus | null = site?.resourceTelemetryStatus || null;

    const status = useMemo(() => {
        if (!resourceTelemetryStatus) return null;

        return determineVenStatusFromTelemetry(resourceTelemetryStatus, !!site?.customer_ven?.ven_enabled);
    }, [resourceTelemetryStatus, site?.customer_ven?.ven_enabled]);

    if (!resourceTelemetryStatus) return <></>;

    const lastSeenString = resourceTelemetryStatus.last_reported
        ? formatDistance(new Date(resourceTelemetryStatus.last_reported), new Date(), { addSuffix: true, includeSeconds: true })
        : null;

    const color = status ? VEN_STATUS_COLOR_MAP[status] : '#888787';

    const statusContent = (
        <div style={{ maxWidth: '200px' }}>
            <div className="device-icon-popover-status">
                <Text type={status === VenStatus.ONLINE ? 'success' : status === VenStatus.DISABLED ? undefined : 'danger'}>
                    {status?.toUpperCase() || 'UNKNOWN'}
                </Text>
            </div>

            {lastSeenString && <div className="device-icon-popover-lastseen">Last seen:&nbsp;{lastSeenString}</div>}
        </div>
    );

    const content = (
        <div className="device-icon-popover">
            <div className="device-icon-popover-title">Resource Status</div>
            <div className="device-icon-popover-title">
                Resource ID: <b>{site?.site_resource_id}</b>
            </div>
            {statusContent}
        </div>
    );

    return (
        <span style={{ display: 'inline-block', position: 'relative', width: 32, height: 32, verticalAlign: 'middle' }}>
            <Popover content={content}>
                <CircleIcon style={{ fontSize: '28px', color }} />
            </Popover>
        </span>
    );
};
